module.exports = __webpack_public_path__ + "img/facebook.cfad22bd.svg";